import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-5" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Document médical")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_5 = { class: "col-12 col-lg-4 m-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "col-lg-4 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "Attention:")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Un document médical est déjà enregistré pour ce compte. Si besoin, vous pouvez en envoyer un nouveau. Dans tous les cas, le document devra être de nouveau validé par notre équipe. ", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "col-lg-4 bg-primary rounded text-light text-start pt-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("u", null, "Attention:")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("u", null, "Si vous participez à la course à pied"),
      /*#__PURE__*/_createTextVNode(" : Le document médical requis est une attestation de Parcours Prévention Santé. Ce document a une durée de "),
      /*#__PURE__*/_createElementVNode("strong", null, "validité de trois mois"),
      /*#__PURE__*/_createTextVNode(". Au-delà de ces trois mois, le document ne sera pas accepté.")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("u", null, "Si vous participez aux autres épreuves"),
      /*#__PURE__*/_createTextVNode(" : Le document médical requis est un certificat médical. Il doit dater de "),
      /*#__PURE__*/_createElementVNode("strong", null, "moins d'un an"),
      /*#__PURE__*/_createTextVNode(" au moment de la compétition et doit comporter l'autorisation de la pratique des disciplines en compétition selon votre course. Les licences des fédérations correspondant aux courses sont acceptées (FFC pour le vélo par exemple). ")
    ])
  ])
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_20 = { class: "col col-lg-4 text-start fw-bold" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "inputCertificate" }, "Document médical: ", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 1,
  type: "file",
  class: "form-control",
  id: "inputCertificate",
  name: "certificate",
  accept: "image/png, image/jpeg,.pdf"
}
const _hoisted_26 = { class: "row mt-5" }
const _hoisted_27 = { class: "col col-lg-6" }
const _hoisted_28 = { class: "col col-lg-6 text-end" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_DisplayCertificateVue = _resolveComponent("DisplayCertificateVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StepBar, { index: 4 })
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.previousCertificateExists && !_ctx.updatePreviousCertificate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16)),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("form", {
            class: "m-2",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadCertificate && _ctx.uploadCertificate(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                (_ctx.previousCertificateExists && !_ctx.updatePreviousCertificate)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "form-control",
                      id: "inputCertificate",
                      name: "certificate",
                      value: _ctx.certificateFile,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCertificateModal(_ctx.certificateFile))),
                      readonly: ""
                    }, null, 8, _hoisted_24))
                  : (_openBlock(), _createElementBlock("input", _hoisted_25))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                (_ctx.previousCertificateExists && !_ctx.updatePreviousCertificate)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activateUpdateCertificate && _ctx.activateUpdateCertificate(...args))),
                      class: "btn btn-primary"
                    }, " Envoyer un nouveau document "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.passCertificateUpload && _ctx.passCertificateUpload(...args))),
                      class: "btn btn-secondary"
                    }, " Passer pour l'instant "))
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.previousCertificateExists && !_ctx.updatePreviousCertificate)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      class: "btn btn-success",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createCertificate && _ctx.createCertificate(...args)))
                    }, " Les informations sont correctes "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "submit",
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.uploadCertificate && _ctx.uploadCertificate(...args)))
                    }, " Envoyer "))
              ])
            ])
          ], 32)
        ]),
        _hoisted_29
      ])
    ]),
    _withDirectives(_createVNode(_component_DisplayCertificateVue, {
      onCloseDisplayCertificateModal: _ctx.toggleDisplayCertificateModal,
      certificateFile: _ctx.certificateFile
    }, null, 8, ["onCloseDisplayCertificateModal", "certificateFile"]), [
      [_vShow, _ctx.showDisplayCertificateModal]
    ])
  ], 64))
}